import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const getPriceCollectionDocumentDetailsSchema = z.array(
  baseObjectSchema.extend({
    priceCollectionDocumentID: z.string(),
    order: z.number(),
    material: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    }),
    competitor: z
      .object({
        id: z.string(),
        code: z.string().optional(),
        profession: z.string().optional(),
      })
      .optional(),
    alterCode: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    }),
    alterDescription: z.string().optional(),
    currentPrice: z.number(),
    shelf: z.string().optional(),
    faces: z.number().optional(),
    lastPrice: z.number(),
    lastCollectionDate: z.string().optional(),
    havePromo: z.boolean(),
    notExist: z.boolean(),
    remarks: z.string().optional(),
    forPrinting: z.boolean(),
  })
);

export type GetPriceCollectionDocumentDetailsResponse = z.infer<
  typeof getPriceCollectionDocumentDetailsSchema
>;
